import { Text, View } from 'react-native';
import { Beaker, FlaskConical } from 'lucide-react-native';

import { ENV_LABELS, env, isProduction } from '@/config/env';
import { typography } from '@/theme/tokens';

export function EnvBanner() {
  if (isProduction) return null;
  const cfg = ENV_LABELS[env];
  const Icon = env === 'staging' ? FlaskConical : Beaker;
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        backgroundColor: cfg.bgColor,
        paddingVertical: 6,
        paddingHorizontal: 12,
      }}
    >
      <Icon size={14} color={cfg.color} />
      <Text
        style={{
          color: cfg.color,
          fontSize: 11,
          fontWeight: typography.weights.bold,
          letterSpacing: 1.4,
        }}
      >
        {cfg.label}
      </Text>
    </View>
  );
}
